module.exports = __webpack_public_path__ + "static/media/19.89b08824.jpg";